/**
 * Converts plaintext into HTML paragraphs.
 * A single newline character creates a line break (`<br>`),
 * while a double newline character denotes a new paragraph (`<p>`).
 *
 * @param {string} plainText - The plaintext input to be converted.
 * @returns {string} - The HTML formatted string.
 *
 * @example
 * const plainText = `This is the first line.\nThis should be a new line within the same paragraph.\n\nThis is the start of a new paragraph.`;
 * console.log(textToHtml(plainText));
 * // Output: "<p>This is the first line.<br>This should be a new line within the same paragraph.</p><p>This is the start of a new paragraph.</p>"
 */
export function textToHtml(plainText) {
  var trimmedText = plainText.trim();
  if (!trimmedText) {
    return '';
  }
  return trimmedText.split(/\n\s*\n+/).filter(p => p.trim() !== '').map(p => p.split('\n').map(line => line.trim()).join('<br>')).map(p => "<p>".concat(p, "</p>")).join('');
}